const state = {
  knuteStore:
    [
      {
        id: 1,
        title_en: "Accounting and Auditing (Title side)",
        title_ua: "Облік і аудит (Титульна сторона)",
        title_es: "Contabilidad y Auditoría (Lado del título)",
        regnumber: "KB 10682421",
        grade_en: "Honors degree",
        grade_ua: "З відзнакою",
        grade_es: "Matrícula de honor",
        examdate: "29.01.1999",
        image: "/assets/documents/knute1.webp",
      },
      {
        id: 2,
        title_en: "Accounting and Auditing (Backside)",
        title_ua: "Облік і аудит (Тильна сторона)",
        title_es: "Contabilidad y Auditoría (Reverso)",
        regnumber: "KB 10682421",
        grade_en: "Honors degree",
        grade_ua: "З відзнакою",
        grade_es: "Matrícula de honor",
        examdate: "29.01.1999",
        image: "/assets/documents/knute2.webp",
      }
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};